import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '../stores/useAuthStore';

export default function PaymentRoute() {
  const user = useAuthStore((s) => s.user);

  // PaymentRequired.tsx reads paymentAccessReason from the store itself (not
  // a URL param) so it can react to state changing after the redirect — the
  // query string here is informational only, not load-bearing.
  if (user?.accountType === 'PAID' && user.paymentAccessReason != null) {
    return <Navigate to="/payment-required" replace />;
  }

  return <Outlet />;
}
